module.exports = __webpack_public_path__ + "static/media/mpc-minting-mobile-comp.6fa8e702.png";